import React from "react"
import isEmpty from "lodash/isEmpty"
import {SearchBannerWrapper, SearchBannerBody, NoSearchBanner} from "./components"
import {INTEL_RECS, STRIP, COPY_TEXT, ROUNDELS, HEADING, CHIPS} from "../utils"
import {RegionWrapper} from "./regions"
import {AccordionCopy} from "../copy"
import {CopyProps} from "../copy/models"
import SearchBannerContainer from "../../searchBannerContainer"

const SIDE_IMAGE = "side-image"
const IMAGE = "image"

export const TemplatedSearchBanner = ({
    paddingTop,
    json,
    hasPreviousPage,
    hasStructuredBrowsing,
    urlIsSaleOrClearance,
}) => {
    if (json == null) {
        return <NoSearchBanner $paddingTop={paddingTop} />
    }
    const banner = json?.containers?.[0]
    // Check if the banner is an intel rec / personalized search banner
    const isIntelRecBanner = banner?.regions.find(region => region.dataSource === INTEL_RECS)
    if (banner == null) {
        return <NoSearchBanner $paddingTop={paddingTop} />
    }
    // split searchbanner into parts
    const images = [] as any[]
    const strips = [] as any[]
    const components = [] as any[]
    let copyRegion: CopyProps | undefined
    banner.regions.forEach(region => {
        if (region.type === IMAGE || region.type === SIDE_IMAGE) {
            images.push(region)
        } else if (region.type === STRIP) {
            strips.push(region)
        } else if (region.type === COPY_TEXT) {
            // we want to limit to one copy
            if (copyRegion == null) {
                copyRegion = region
                // Don't push the copy region to components in case of accordion set to true
                // so that we can show it in the mobile copy component as a accordion

                if (!region.accordion) {
                    components.push(region)
                }
            }
        } else {
            components.push(region)
        }
    })
    // if the banner is an intel rec banner, we want to sort the components in a specific order
    if (!isEmpty(isIntelRecBanner)) {
        // Define the desired order for intel rec(personalized search) banner
        const intelRecBannerOrder = [COPY_TEXT, ROUNDELS, HEADING, CHIPS, STRIP]
        // Sort the components based on the order defined
        components.sort((a, b) => {
            return intelRecBannerOrder.indexOf(a.type) - intelRecBannerOrder.indexOf(b.type)
        })
    }
    // if the banner is an accordion copy, we want to show it as a copy only
    const copyOnly = !!copyRegion && [components, images, strips].every(arr => arr.length === 0)
    const isAccordionCopy = copyRegion?.accordion === true
    const imageOnly = images.length > 0 && strips.length === 0 && components.length === 0

    return (
        <SearchBannerWrapper
            $hasPreviousPage={hasPreviousPage}
            data-testid="plp-search-banner"
            $urlIsSaleOrClearance={urlIsSaleOrClearance}
        >
            <SearchBannerContainer $paddingTop={paddingTop} $copyOnly={copyOnly}>
                <>
                    {copyRegion != null && (
                        <AccordionCopy
                            content={copyRegion?.content}
                            overrideStyles={copyRegion?.overrideStyles}
                            isIntelRecs={!isEmpty(isIntelRecBanner)}
                            showAccordionOnDesktop={isAccordionCopy}
                        />
                    )}
                    <SearchBannerBody $bannerStyles={banner.overrideStyles} $copyOnly={copyOnly}>
                        <RegionWrapper
                            hasSideImage={banner.type === SIDE_IMAGE}
                            copyOnly={copyOnly}
                            imageOnly={imageOnly}
                            images={images}
                            components={components}
                            strips={strips}
                            hasCopy={copyRegion != null}
                            hasStructuredBrowsing={hasStructuredBrowsing}
                        />
                    </SearchBannerBody>
                </>
            </SearchBannerContainer>
        </SearchBannerWrapper>
    )
}
